import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import makeClassNameComponent, {
  type ClassNameComponent,
} from 'src/utils/makeClassNameComponent';

import css from './popover.css';


type Props = {
  label: string;
  sublabel?: React.ReactNode;
  TagName?: string;
  children: React.ReactNode;
};

export function FormPair({
  label,
  sublabel,
  TagName = 'label',
  children,
}: Props) {
  const {t, makeKey} = useLabelTranslation();
  return (
    // @ts-expect-error - TS2322 - Type '{ children: (ReactNode | Element)[]; className: string; }' is not assignable to type 'IntrinsicAttributes'.
    <TagName className={css.formPair}>
      <div className={css.formPairTitle}>
        <span className={css.formLabel}>{t(makeKey(label), label)}</span>

        <span className={css.formSublabel}>{sublabel}</span>
      </div>

      {children}
    </TagName>
  );
}

export function SmallFormPair({label, children}: Props) {
  const {t, makeKey} = useLabelTranslation();
  return (
    <label className={css.formPair}>
      <span className={css.formLabelSmall}>{t(makeKey(label), label)}</span>

      {children}
    </label>
  );
}

export function FormGroup({
  label,
  children,
  tooltip,
}: Props & {
  tooltip?: React.ReactNode;
}) {
  const {t, makeKey} = useLabelTranslation();
  return (
    <div className={css.formGroup}>
      {tooltip ? (
        <div className={css.labelRow}>
          <span className={css.formLabel}>{t(makeKey(label), label)}</span>

          {tooltip}
        </div>
      ) : (
        <span className={css.formLabel}>{t(makeKey(label), label)}</span>
      )}

      <div className={css.formGroupContent}>{children}</div>
    </div>
  );
}

// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const ButtonsSmall: ClassNameComponent = makeClassNameComponent(
  css.buttonsSmall,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const ButtonsLarge: ClassNameComponent = makeClassNameComponent(
  css.buttonsLarge,
);
